import ReglaLecturacionDetalleDAL from '../DAL/ReglaLecturacionDetalleDAL';
import MedidorAnormalidadDAL from '../DAL/MedidorAnormalidadDAL';
import GeneracionLecturaDAL from '../DAL/GeneracionLecturaDAL';
import GeneracionLecturaMovilDAL from '../DAL/GeneracionLecturaMovilDAL';   
import MediaConsumoDAL from '../DAL/MediaConsumoDAL';
import CategoriaConsumoDAL from '../DAL/CategoriaConsumoDAL';
import AnormalidadCorrectaBLL from '../BLL/AnormalidadCorrectaBLL';
import ModificacionGeneracionLecturaDAL from '../DAL/ModificacionGeneracionLecturaDAL';


export default class GeneracionLecturaBLL {
    // Declaración de propiedades
    gnCliente;
    gnGeneracionFactura;
    gnMedidorAnormalidad;
    gnLecturaAnterior;
    gnLecturaActual;
    gnMedidor;
    gnTipoConsumo;
    gnConsumoFacturado;
    nErrorAdvertencia;
    nError;
    gnConsumoActual;
    gnMedia;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
    gnMediaAnterior;
    gnCategoria;
    gnAjusteConsumo;
    gnAjusteMonto;
    gnPorcentajeDesviacion;
    llswMedidorVolcadoEnLimiteMAX = false;
    ID_Clase = 2000;
    AplicarPromedio;
    DesviacionSignificativa;
    InspeccionRequerido;
    Facturado;
    ValidoLectura;
    gnConsumoMinimo = 0;
    Regla = 0;
    swProcesadoCliente = false;
    cMessage;
    MedidorInfo = {};
    TipoConsumo = {};
    TipoComportamiento = {};
    ReglaLecturacion = {};
    DataBaseAlias;
    gnMedidorAnormalidad2;
    gnCobro;
    oAnormalidadCorrectaBLL;
    gnAnormalidadEspecial = 0;
    cTipoConsumoNombre;
    cSeleccionAnormalidadValida = "Seleccione una Anoramalidad Valida";
    oClienteDatos = null;
    // oGeneracionFactura = null;

    constructor() {
        // this.MedidorInfo = new MedidorInfo();
        this.TipoConsumo =  {
            ConsumoNormal   : 1,
            ConsumoBajo     : 2,
            ConsumoAlto     : 3,
            ConsumoCero     : 4,
            ConsumoNegativo : 5,
            SinLectura      : 6,
            ConsumoEstimado : 7,
            ConsumoIrreal   : 8,
        };
        // this.TipoComportamiento =  new TipoComportamiento();
        this.TipoComportamiento = {
            Lecturable           : 1,
            NoLecturable         : 2,
            FinDeCiclo           : 3,
            VolcadoAntesDeLimite : 4,
            VolcadoEnLimite      : 5,
            Estimado             : 6,
            Irreal               : 7,
        };
        // this.ReglaLecturacion = new ReglaLecturacion(); 
        this.ReglaLecturacion = {
           LECTURA_PENDIENTE : 1,
            LECTURA_ACTUAL   : 2,
            FIN_DE_CICLO     : 3,
            CONSUMO_PROMEDIO : 4,
            MEDIDOR_VOLCADO  : 5,
            CONSUMO_ASIGNADO : 6, 
        }

        this.oAnormalidadCorrectaBLL = new AnormalidadCorrectaBLL();
        this.cTipoConsumoNombre =  'SIN TIPO CONSUMO...';

   }

    async ModificarYValidarLectura(taParametros, toClienteDatos) {
        try {
     
            let lnResult = 0;
            this.nError = 0;
            let lnConsumoMinimo = 0;
            this.nErrorAdvertencia = 0;
            this.gnMedidorAnormalidad2 = taParametros.tnMedidorAnormalidad2;

            let Consumo = taParametros.tnLecturaActual - taParametros.tnLecturaAnterior;
           
            lnResult = await this.InicializarCampos(
                taParametros.tnCliente,
                taParametros.tnGeneracionFactura,
                taParametros.tnLecturaActual,
                Consumo,
                taParametros.tnMedidorAnormalidad,
                taParametros.tnMedidor,
                taParametros.tnCategoria,
                taParametros.tnCobro,
                taParametros.DataBaseAlias,
                toClienteDatos
            );
            
           
      
            if (lnResult != 0) { 
                this.nError = this.ID_Clase + lnResult;
                //RESUELTO
                return await this.ResultadoModificacionLecturaCliente();
            }
     
            // const categoriaDAL = new CategoriaDAL();
            // lnConsumoMinimo = await categoriaDAL.GetConsumoMinimo(taParametros.tnCategoria, taParametros.DataBaseAlias);
            lnConsumoMinimo = [];
            lnConsumoMinimo.push({
                'ConsumoMinimo' : this.oClienteDatos.ConsumoMinimo
             });

            this.gnConsumoMinimo = lnConsumoMinimo[0].ConsumoMinimo;
            this.gnMedia = taParametros.tnMedia;
            this.gnLecturaAnterior = this.oClienteDatos.LecturaAnterior;
            this.gnLecturaAnterior = Number(this.gnLecturaAnterior);
            this.gnLecturaActual = Number(this.gnLecturaActual);

        
      
            const lnEspecial = await this.verificarAnormalidadesEspeciales();
            if (lnEspecial == 0  ) {   
                lnResult = await this.ValidarLectura(
                    taParametros.tnCliente,
                    taParametros.tnGeneracionFactura,
                    taParametros.tnLecturaActual,
                    Consumo,
                    taParametros.tnMedidorAnormalidad,
                    taParametros.tnMedia,
                    lnConsumoMinimo
                );
            }

      
            
            let llSeValida = true;
    
            if (this.gnAnormalidadEspecial == 0) {
                //RESUELTO
        
                llSeValida = await this.SeValida(taParametros.tnMedia, Consumo, taParametros.tnCategoria, taParametros.DataBaseAlias);
                if (llSeValida) {
                    if (lnResult != 0) {
                        
                        this.nError = this.ID_Clase + lnResult;
                         //RESUELTO
                        return await this.ResultadoModificacionLecturaCliente();
                    }
                } else {
                    lnResult = 0;
                    this.nError = 0;
                }
            }

            if (taParametros.tnGlosa != '') {
             
                 lnResult = await this.DO_CopiarToModGenLe(
                    taParametros.tnCliente,
                    taParametros.tnGeneracionFactura,
                    taParametros.tnGlosa
                );
            }
            



      
            if (this.gnAnormalidadEspecial == 0) {
                if (lnResult == 0) {
                        
                    lnResult = await this.AplicarRegla(llSeValida);
                }
            } else {
                lnResult = await this.AplicarRegla(false);
            }

            this.nError = this.ID_Clase + lnResult;
            
            return await this.ResultadoModificacionLecturaCliente();
        } catch (th) {
            console.error("==> Error Grave", th);
            // GuardarErrores.GuardarErrores(th, 0, "ModificarYValidarLectura()");
            throw th;
        }
    }

    //RESUELTO
    async InicializarCampos(tcCliente, tnGeneracionLectura, tnLecturaActual, tnConsumo, tnMedidorAnormalidad, tnMedidor, tnCategoria, tcCobro, tcDataBaseAlias, toClienteDatos) {
        try {
       
            // CAMPOS PARA LA TABLA GENERACIONLECTURA
            this.gnCliente = tcCliente;
            this.gnGeneracionFactura = tnGeneracionLectura;
            this.gnMedidorAnormalidad = tnMedidorAnormalidad;
            this.gnLecturaActual = tnLecturaActual;
            this.gnConsumoActual = tnConsumo;
            this.gnMedia = 0;
            this.gnMediaAnterior = false;

            // CAMPOS PARA LA TABLA GENERACIONLECTURAMOVIL
            this.gnCategoria = tnCategoria;
            this.gnMedidor = tnMedidor;
            this.gnTipoConsumo = 0;
            this.AplicarPromedio = false;
            this.gnAjusteConsumo = 0;
            this.gnAjusteMonto = 0;
            this.gnConsumoFacturado = tnConsumo;
            this.DesviacionSignificativa = false;
            this.InspeccionRequerido = false;
            this.Facturado = false;
            this.ValidoLectura = false;
            this.gnCobro = tcCobro;

            this.DataBaseAlias = tcDataBaseAlias;
            this.oClienteDatos = toClienteDatos;

            let texto = { "ConsumoActual": "ConsumoActual" + this.gnConsumoActual };
            // Aquí deberías guardar 'texto' en un archivo si es necesario.
            // Ejemplo:
            // await someStorageFunction('Error/error_CA_.txt', JSON.stringify(texto));

            

            return 0;
        } catch (th) {
            console.error("Error:", th);
            return 1;
        }
    }

    //RESUELTO
    async ResultadoModificacionLecturaCliente() {
      
        let Resultado = {};

        const MedidorDAL = [];
        MedidorDAL.push({
            'NumeroSerie' : this.oClienteDatos.NumeroSerie,
            'Numero' : this.oClienteDatos.Numero,
            'FinMedidor' : this.oClienteDatos.FinMedidor,
            'MarcaMedidor' : this.oClienteDatos.MarcaMedidor
        })

        // let CategoriaDAL = new CategoriaDAL();
        // CategoriaDAL = await CategoriaDAL.GetRecDt(this.gnCategoria, this.DataBaseAlias);
        const CategoriaDAL = [];
        CategoriaDAL.push({
            'NombreCategoria' : this.oClienteDatos.NombreCategoria
        });


        // let MedidorAnormalidadDAL = new MedidorAnormalidadDAL();
        // MedidorAnormalidadDAL = await MedidorAnormalidadDAL.GetRecDt(this.gnMedidorAnormalidad, this.DataBaseAlias);
        const MedidorAnormalidadDAL = [];
        MedidorAnormalidadDAL.push({
            'NombreAnormalidad' : this.oClienteDatos.NombreAnormalidad,
            'Regla' : this.oClienteDatos.Regla
        });
        

        let NombreAnormalidad = "N/E";
        let NombreCategoria = "N/E";
        let MedidorMarca = "N/E";
        let MedidorSerie = "N/E";
        let MedidorNumero = "N/E";

        if (MedidorAnormalidadDAL.length > 0) {
            NombreAnormalidad = MedidorAnormalidadDAL[0].NombreAnormalidad;
            this.Regla = MedidorAnormalidadDAL[0].Regla;
        }

        if (CategoriaDAL.length > 0) {
            NombreCategoria = CategoriaDAL[0].NombreCategoria;
        }

        if (MedidorDAL.length > 0) {
             // const MarcaMedidorDAL = new MarcaMedidorDAL();
            // let marcaMedidorResult = await MarcaMedidorDAL.GetRecDt(MedidorDAL[0].MarcaMedidor, this.DataBaseAlias);
            const marcaMedidorResult = [];
            marcaMedidorResult.push({
                'NombreMarcaMedidor' : this.oClienteDatos.NombreMarcaMedidor
            });

            if (marcaMedidorResult.length > 0) {
                MedidorMarca = marcaMedidorResult[0].NombreMarcaMedidor;
            } else {
                MedidorMarca = "N/E";
            }
            MedidorSerie = MedidorDAL[0].NumeroSerie;
            MedidorNumero = MedidorDAL[0].Numero;
        }

        Resultado = {
            "Error": this.nError,
            "TipoConsumo": this.GetTipoConsumoStr(), 
            "Media": this.gnMedia,
            "DesviacionSignificativa": this.DesviacionSignificativa,
            "ConsumoActual": this.gnConsumoActual,
            "LecturaAnterior": this.gnLecturaAnterior,
            "LecturaActual": this.gnLecturaActual,
            "Anormalidad": NombreAnormalidad,
            "Categoria": NombreCategoria,
            "MedidorMarca": MedidorMarca,
            "MedidorSerie": MedidorSerie,
            "MedidorNumero": MedidorNumero,
            "PorcentajeDesviacion": this.gnPorcentajeDesviacion,
            "ProcesadoCliente": this.swProcesadoCliente,
            "Regla": this.Regla,
            "FinMedidor": MedidorDAL[0].FinMedidor,
            "MedidorVolcado": this.llswMedidorVolcadoEnLimiteMAX
        };

        return Resultado;
    }
    //RESUELTO
    async ValidarLectura(tcCliente, tcGeneracionLectura, tcLecturaActual, tnConsumo, tcMedidorAnormalidad, tcMedia, tnConsumoMinimo) {
        try {

            this.gnConsumoMinimo = parseInt(tnConsumoMinimo[0].ConsumoMinimo);
            // const MedidorAnormalidadDAL = new MedidorAnormalidadDAL(); //no se esta llamando
            // const GeneracionLecturaDAL = new GeneracionLecturaDAL();
            // const lnLecturaAnteriorDAL = await GeneracionLecturaDAL.GetRecDt2(tcGeneracionLectura, tcCliente, this.DataBaseAlias);
            // const lnLecturaAnteriorDAL = [];
            // lnLecturaAnteriorDAL.push({
            //     'LecturaAnterior' : 0
            // });
            //------ no hizo falta, solo trae lectura anterior ------------


            let lnResult = 0;
            this.gnMedia = tcMedia;
            // this.gnLecturaAnterior = lnLecturaAnteriorDAL[0].LecturaAnterior;
            this.gnLecturaAnterior = Number(this.oClienteDatos.LecturaAnterior);
            tcLecturaActual = Number(tcLecturaActual);
            tcMedidorAnormalidad = Number(tcMedidorAnormalidad);

            //RESUELTO
            this.nError = await this.GetTipoComportamiento(tcCliente, tcGeneracionLectura, tcLecturaActual);
            //devolvio 0, por lo que continua
            
            if (this.nError != 0) {
                return this.nError; // Error al identificar el comportamiento del medidor
            }
         
            // Nota: Verificación de la lectura anterior y actual
            if ((this.gnLecturaAnterior >= 0) && (tcLecturaActual == 0) && (tcMedidorAnormalidad > 0)) {
             //RESUELTO
          
                lnResult = await this.AnormalidadCorrecta(tcMedidorAnormalidad, this.TipoConsumo.SinLectura, this.TipoComportamiento.NoLecturable);

                if (lnResult == 0) {
                    this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.NoLecturable;
                    this.MedidorInfo.MedidorTipoConsumo = this.TipoConsumo.SinLectura;
                 //RESUELTO
                    this.cTipoConsumoNombre =  this.GetNombreTipoConsumo(this.TipoConsumo.SinLectura);
                    return lnResult;
                } else {
                    if (this.MedidorInfo.MedidorTipoConsumo == this.TipoConsumo.ConsumoNegativo) {
                        this.gnTipoConsumo = this.MedidorInfo.MedidorTipoConsumo;
                    } else {
                        //RESUELTO
                        this.gnTipoConsumo = await this.GetTipoConsumo(tcGeneracionLectura, tcLecturaActual, tcMedia);
                        this.cTipoConsumoNombre =  this.GetNombreTipoConsumo(this.gnTipoConsumo);
                    }
               //RESUELTO
                    lnResult = await this.AnormalidadCorrecta(tcMedidorAnormalidad, this.gnTipoConsumo, this.MedidorInfo.MedidorTipoComportamiento);
                    if (lnResult != 0) {
                        this.cMessage = `Anormalidad no válida ${this.gnTipoConsumo} - ${this.MedidorInfo.MedidorTipoComportamiento}`;
                        return lnResult;
                    }
                    return lnResult;
                }
            }

            // Nota: Verificación tipo de consumo, si es negativo y la anormalidad es incorrecta
            if ((this.MedidorInfo.MedidorTipoConsumo == this.TipoConsumo.ConsumoNegativo) && (tcLecturaActual == 0) && (this.gnLecturaActual > 0)) {
                this.nErrorAdvertencia = 1;
                this.cMessage = 'Seleccione Anormalidad Correcta';
            }

            // Nota: Verificación tipo de consumo, si es negativo
            if (this.MedidorInfo.MedidorTipoConsumo == this.TipoConsumo.ConsumoNegativo) {
                this.gnTipoConsumo = this.MedidorInfo.MedidorTipoConsumo;
            } else {
          //RESUELTO
                this.gnTipoConsumo = await this.GetTipoConsumo(tcGeneracionLectura, tcLecturaActual, tcMedia);
            }
            //RESUELTO
            this.cTipoConsumoNombre = this.GetNombreTipoConsumo(this.gnTipoConsumo);

            if (this.MedidorInfo.MedidorTipoComportamiento == this.TipoComportamiento.Lecturable) {
                this.MedidorInfo.MedidorTipoConsumo = this.gnTipoConsumo;
                this.MedidorInfo.MedidorConsumo = this.gnConsumoActual;
            }

            this.DesviacionSignificativa = (this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo || this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto);

            if (tcMedidorAnormalidad == 0) {
                if (this.gnTipoConsumo == this.TipoConsumo.ConsumoNormal) {
                    lnResult = 0;
                    if (tnConsumo > 0 && this.gnConsumoFacturado < tnConsumo && this.gnConsumoMinimo > 0) {
                        lnResult = 5;
                        this.cMessage = '[ConsumoFacturado < Consumo] Corregir ConsumoFacturado';
                    }
                } else {
                    if (this.gnLecturaAnterior == 0 && this.gnLecturaActual == 0 && this.TipoConsumo.ConsumoCero == this.gnTipoConsumo) {
                        lnResult = 2;
                        this.cMessage = 'Consulte con Administrador';
                    } else {
                        if (this.gnConsumoActual <= this.gnConsumoMinimo && this.gnConsumoActual > 0 && this.gnMedia <= this.gnConsumoMinimo && this.gnTipoConsumo != 5) {
                            lnResult = 0;
                        } else {
                            lnResult = 2;
                            this.gnConsumoActual = this.MedidorInfo.MedidorConsumo;
                            if (this.nErrorAdvertencia == 0) {
                                this.cMessage = `[${this.cTipoConsumoNombre}] - ${this.cSeleccionAnormalidadValida}`;
                            }
                        }
                    }
                }
            } else {
                this.gnConsumoFacturado = this.gnMedia;
                 //RESUELTO
                lnResult = await this.EsCasoSinLectura_AplicarPromedio(tcMedidorAnormalidad, this.gnTipoConsumo, this.gnLecturaAnterior,
                    this.gnLecturaActual, this.gnConsumoActual, this.gnMedia, this.gnConsumoFacturado, tnConsumoMinimo);

                if (lnResult != 4) {
                    if (lnResult > 0) {
                       //RESUELTO
                        lnResult = await this.AnormalidadCorrecta(tcMedidorAnormalidad, this.gnTipoConsumo, this.MedidorInfo.MedidorTipoComportamiento);
                    }
                }
            }
            return lnResult;
         //RESUELTO
            // this.nError = await this.verificarAnormalidadesEspeciales();
            // if (this.nError == 1) {
            //     return 0;
            // } else {
            //     return lnResult;
            // }

        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    //RESUELTO
    async SeValida(tcMedia, Consumo, tcCategoria, DataBaseAlias) {
        let lnValorRef = 15;
        let llSeValida = true;
        
       

        if (tcCategoria > 0) {
            const categoriaConsumoDAL = new CategoriaConsumoDAL();
            const lnResult = await categoriaConsumoDAL.getCategoriaConsumoInicio(tcCategoria);
            // const lnResult = await CategoriaConsumo.on(DataBaseAlias)
            //     .where('Categoria', '=', tcCategoria)
            //     .where('Inicio', '=', '0')
            //     .get();

            
            if (lnResult.length > 0) {
                lnValorRef = lnResult[0].Fin;
            }
        }

        if (Consumo > 0) {
            const MediaConsumoXD = new MediaConsumoDAL();
            llSeValida = await MediaConsumoXD.SeValida(tcMedia, Consumo, lnValorRef, DataBaseAlias);
            
       
        } else {
            llSeValida = true;
        }

        return llSeValida;
    }


    //YA NO SE DEBERIA APLICAR
    async DO_CopiarToModGenLe(tcCliente, tcGeneracionLectura, tnGlosa) {     
  
        const MedidorAnormalidadDal = new MedidorAnormalidadDAL();
        const ModificacionGeneracionLecturaDal = new ModificacionGeneracionLecturaDAL;

        const GeneracionLecturaDal = new GeneracionLecturaDAL();
        const GeneracionLectura = await GeneracionLecturaDal.GetRecDt2(tcGeneracionLectura, tcCliente, this.DataBaseAlias);

        const generacionLecturaMovilDal = new GeneracionLecturaMovilDAL();
        let DatosCliente = await generacionLecturaMovilDal.GetRecDt(tcGeneracionLectura, tcCliente, this.DataBaseAlias);
     
        if (GeneracionLectura.length == 0) {
            return 9;
        }

        if (DatosCliente.length == 0) {
            const MedidorAnormalidad = GeneracionLectura[0].MedidorAnormalidad;
            const Auxiliar = await MedidorAnormalidadDal.GetRecDt(MedidorAnormalidad, this.DataBaseAlias);
            let TipoConsumoAnterior = 0;

            if (Auxiliar.length > 0) {
                TipoConsumoAnterior = Auxiliar[0].TipoConsumo;
            }

    
            await generacionLecturaMovilDal.Insert(0, tcGeneracionLectura, tcCliente, this.gnCategoria, this.gnMedidor, TipoConsumoAnterior,
            this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto, this.DesviacionSignificativa,
            this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias);

            DatosCliente = await generacionLecturaMovilDal.GetRecDt(tcGeneracionLectura, tcCliente, this.DataBaseAlias);
        }
       
        const ModificacionGeneracionLectura = {
            // Datos ModificacionGeneracionLectura
            GeneracionFactura: tcGeneracionLectura,
            Cliente: tcCliente,
            Glosa: tnGlosa, 
          
            // Datos GeneracionLectura
            CodigoUbicacion: GeneracionLectura[0].CodigoUbicacion,
            LecturaAnterior: GeneracionLectura[0].LecturaAnterior,
            LecturaActual: GeneracionLectura[0].LecturaActual,
            Consumo: GeneracionLectura[0].Consumo,
            MedidorAnormalidad: GeneracionLectura[0].MedidorAnormalidad,
            MediaAnterior: GeneracionLectura[0].MediaAnterior,
            Cobro: GeneracionLectura[0].Cobro,
            Media: GeneracionLectura[0].Media,
            ConsumoFacturado: GeneracionLectura[0].ConsumoFacturado,
            ConsumoDebito: GeneracionLectura[0].ConsumoDebito,

            // Datos GeneracionLecturaMovil
            FechaAnterior: DatosCliente[0].Fecha,
            HoraAnterior: DatosCliente[0].Hora,
            Categoria: DatosCliente[0].Categoria,
            Medidor: DatosCliente[0].Medidor,
            TipoConsumo: DatosCliente[0].TipoConsumo,
            MedidorAnormalidad2: DatosCliente[0].MedidorAnormalidad2,
            AplicoMedia: DatosCliente[0].AplicoMedia,
            ConsuFactu: DatosCliente[0].ConsuFactu,
            AjusteConsumo: DatosCliente[0].AjusteConsumo,
            AjusteMonto: DatosCliente[0].AjusteMonto,
            DesviacionSignificativa: DatosCliente[0].DesviacionSignificativa,
            InspeccionRequerida: DatosCliente[0].InspeccionRequerido,
            Facturado: DatosCliente[0].Facturado,
            ValidoLectura: DatosCliente[0].ValidoLectura,

            DataBaseAlias: this.DataBaseAlias,
        };

      
        await ModificacionGeneracionLecturaDal.Insertar(ModificacionGeneracionLectura);

        return 0;
    }
    //RESUELTO
    async AplicarRegla(tlSeValida) {
      
         //RESUELTO
    
         const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
         await this.verificarConsumoFacturado();

        let lnResult = 0;
        const TipoReglaAplicar = await medidorAnormalidadDAL.Get_TipoReglaAAplicar(this.gnMedidorAnormalidad, this.DataBaseAlias);

        if (!tlSeValida) {
            lnResult = await this.Aplicar_LecturaActual();
        } else {
            if (this.gnMedidorAnormalidad == 0 && (this.gnTipoConsumo == this.TipoConsumo.ConsumoNormal || this.gnConsumoActual <= this.gnConsumoMinimo)) {
                return await this.Aplicar_ConsumoNormal();
            }

            switch (Number(TipoReglaAplicar)) {
                case 1:
                    lnResult = await this.Aplicar_LecturaPendiente();
                    break;
                case 2:
                    lnResult = await this.Aplicar_LecturaActual();
                    break;
                case 3:
                    lnResult = await this.Aplicar_FinDeCiclo();
                    break;
                case 4:
                    lnResult = await this.Aplicar_ConsumoPromedio();
                    break;
                case 5:
                    lnResult = await this.Aplicar_MedidorVolcado();
                    break;
                case 6:
                    lnResult =  this.Aplicar_ConsumoAsignado();
                    break;
                case 7:
                    lnResult =  this.Aplicar_AjusteLectura();
                    break;
                case 8:
                    lnResult = this.Aplicar_InstalacionNueva();
                    break;
                case 9:
                    lnResult = this.Aplicar_CambioDeMedidor();
                    break;
                case 10:
                    lnResult = this.Aplicar_RegularizacionBajaTemporal();
                    break;
                default:
                    lnResult = 0;
                    break;
            }
        }
        return lnResult;
    }

    
    async Aplicar_LecturaActual() {
        try {
        const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
        const generacionLecturaDAL = new GeneracionLecturaDAL();
        const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();
    
        this.ValidoLectura = true;
        const tipoReglaAplicar = medidorAnormalidadDAL.Aplicar_LecturaActual;
    
            // TODO : verificar que el consumo facturado sea menor al minimo debe guardar con el consumo minino Categoria.ConsumoMinimo
            await generacionLecturaDAL.actualizarLecturaDAL( tipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual, this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado
            );

            // Campos para la table GeneracionLecturaMovil
            this.AplicarPromedio = false;
            this.gnAjusteConsumo = 0;
            this.gnAjusteMonto   = 0;

            //$this->gnConsumoFacturado = 0; // TODO : guardar segun calculo
            this.DesviacionSignificativa = ((this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo) || (this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto));
            const MedidorAnormalidad = await medidorAnormalidadDAL.GetRecDt(this.gnMedidorAnormalidad, this.DataBaseAlias);
            this.InspeccionRequerido = MedidorAnormalidad[0].Inspeccion;
    

            // Verificar si existe registro en GeneracionLecturaMovil
            const existe = await generacionLecturaMovilDAL.Existe( this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);
    
          if (existe.length > 0) {
            // Actualizar registro existente
                await generacionLecturaMovilDAL.Update(tipoReglaAplicar,this.gnGeneracionFactura,this.gnCliente,this.gnCategoria,this.gnMedidor,this.gnTipoConsumo,this.AplicarPromedio,this.gnConsumoFacturado,this.gnAjusteConsumo,this.gnAjusteMonto,this.DesviacionSignificativa,this.InspeccionRequerido,this.Facturado,this.ValidoLectura,this.gnMedidorAnormalidad2,this.DataBaseAlias);
          } else {
            // Insertar nuevo registro
            await generacionLecturaMovilDAL.Insert(
              tipoReglaAplicar,
              this.gnGeneracionFactura,
              this.gnCliente,
              this.gnCategoria,
              this.gnMedidor,
              this.gnTipoConsumo,
              this.AplicarPromedio,
              this.gnConsumoFacturado,
              this.gnAjusteConsumo,
              this.gnAjusteMonto,
              this.DesviacionSignificativa,
              this.InspeccionRequerido,
              this.Facturado,
              this.ValidoLectura,
              this.gnMedidorAnormalidad2,
              this.DataBaseAlias
            );
          }
    
          return 0;
        } catch (error) {
          console.error("Error en GeneracionLecturaBLL->Aplicar_LecturaActual:", error);
          // Guardar errores en un log si fuera necesario
          return 5;
        }
      }

      async Aplicar_ConsumoNormal() {
        try {
          const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
          const generacionLecturaDAL = new GeneracionLecturaDAL();
          const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();
    
          const tipoReglaAplicar = medidorAnormalidadDAL.Aplicar_ConsumoNormal;
          this.ValidoLectura = true;
          // Actualizar la lectura
          await generacionLecturaDAL.actualizarLecturaDAL( tipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual, this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado );
    
          
            // Campos para la tabla GeneracionLecturaMovil
            this.AplicarPromedio   = false;
            this.gnAjusteConsumo    = 0;
            this.gnAjusteMonto      = 0;
            //this.gnConsumoFacturado = 0;
            this.DesviacionSignificativa = ((this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo) || (this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto));
            this.InspeccionRequerido = false;
            this.Facturado = false;
    
          // Verificar si existe registro en GeneracionLecturaMovil
          const existe = await generacionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);
    
          if (existe.length > 0) {
            // Actualizar registro existente
            await generacionLecturaMovilDAL.Update(
              tipoReglaAplicar,
              this.gnGeneracionFactura,
              this.gnCliente,
              this.gnCategoria,
              this.gnMedidor,
              this.gnTipoConsumo,
              this.AplicarPromedio,
              this.gnConsumoFacturado,
              this.gnAjusteConsumo,
              this.gnAjusteMonto,
              this.DesviacionSignificativa,
              this.InspeccionRequerido,
              this.Facturado,
              this.ValidoLectura,
              this.gnMedidorAnormalidad2,
              this.DataBaseAlias
            );
          } else {
            // Insertar nuevo registro
            await generacionLecturaMovilDAL.Insert(
              tipoReglaAplicar,
              this.gnGeneracionFactura,
              this.gnCliente,
              this.gnCategoria,
              this.gnMedidor,
              this.gnTipoConsumo,
              this.AplicarPromedio,
              this.gnConsumoFacturado,
              this.gnAjusteConsumo,
              this.gnAjusteMonto,
              this.DesviacionSignificativa,
              this.InspeccionRequerido,
              this.Facturado,
              this.ValidoLectura,
              this.gnMedidorAnormalidad2,
              this.DataBaseAlias
            );
          }
    
          return 0;
    
        } catch (error) {
          console.error("Error en GeneracionLecturaBLL->Aplicar_ConsumoNormal:", error);
          // Guardar errores en un log si fuera necesario
          return 3;
        }
      }


    async Aplicar_LecturaPendiente() {
        try {
            const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
            const generacionLecturaDAL = new GeneracionLecturaDAL();
            const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();

            const TipoReglaAplicar = medidorAnormalidadDAL.Aplicar_LecturaPendiente;
            this.gnLecturaActual = 0; 
            this.gnConsumoActual = 0; 

            await generacionLecturaDAL.actualizarLecturaDAL(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual,
                this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado); 

            const existe = await generacionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);

            if (existe.length > 0) {
                await generacionLecturaMovilDAL.Update(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); 
            } else {
                await generacionLecturaMovilDAL.Insert(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); 
            }

            return 0;

        } catch (th) {
            GuardarErrores.GuardarErrores(th, 0, "GeneracionLecturaBLL->Aplicar_LecturaPendiente");
            return 4;
        }
    }

    // async Aplicar_LecturaActual() {
    //     try {
    //         const MedidorAnormalidadDAL = new MedidorAnormalidadDAL();
    //         const GeneracionLecturaDAL = new GeneracionLecturaDAL();
    //         const GeneracionLecturaMovilDAL = new GeneracionLecturaMovilDAL();

    //         this.ValidoLectura = true;
    //         const TipoReglaAplicar = MedidorAnormalidadDAL.Aplicar_LecturaActual;

    //         await GeneracionLecturaDAL.actualizarLecturaDAL(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual,
    //             this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado); // TODO: this.gnConsumoFacturado

    //         // Campos para la tabla GeneracionLecturaMovil
    //         this.AplicarPromedio = false;
    //         this.gnAjusteConsumo = 0;
    //         this.gnAjusteMonto = 0;
    //         this.DesviacionSignificativa = (this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo || this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto);
            
    //         const MedidorAnormalidad = await MedidorAnormalidadDAL.GetRecDt(this.gnMedidorAnormalidad, this.DataBaseAlias);
    //         this.InspeccionRequerido = MedidorAnormalidad[0].Inspeccion;
    //         this.Facturado = false;

    //         const existe = await GeneracionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);

    //         if (existe.length > 0) {
    //             await GeneracionLecturaMovilDAL.Update(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
    //                 this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
    //                 this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
    //         } else {
    //             await GeneracionLecturaMovilDAL.Insert(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria,
    //                 this.gnMedidor, this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
    //                 this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
    //         }

    //         return 0;
    //     } catch (th) {
    //         GuardarErrores.GuardarErrores(th, 0, "GeneracionLecturaBLL->Aplicar_LecturaActual");
    //         return 5;
    //     }
    // }

    async Aplicar_FinDeCiclo() {
        try {
 
            const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
            const generacionLecturaDAL = new GeneracionLecturaDAL();
            const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();

            const TipoReglaAplicar = medidorAnormalidadDAL.Aplicar_FinDeCiclo;
            this.gnTipoConsumo = await this.CalcularConsumoXFinDeCiclo(this.gnCliente, this.gnGeneracionFactura, this.gnLecturaActual);
            this.ValidoLectura = true;

            await generacionLecturaDAL.actualizarLecturaDAL(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual,
                this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado); // TODO: this.gnConsumoFacturado

            // Campos para la tabla GeneracionLecturaMovil
            this.AplicarPromedio = false;
            this.gnAjusteConsumo = 0;
            this.gnAjusteMonto = 0;

            this.DesviacionSignificativa = (this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo || this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto);
            const MedidorAnormalidad = await medidorAnormalidadDAL.GetRecDt(this.gnMedidorAnormalidad, this.DataBaseAlias);
            this.InspeccionRequerido = MedidorAnormalidad[0].Inspeccion;
            this.Facturado = false;

            const existe = await generacionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);
            if (existe.length > 0) {
                await generacionLecturaMovilDAL.Update(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            } else {
                await generacionLecturaMovilDAL.Insert(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            }

            return 0;

        } catch (th) {
            // GuardarErrores.GuardarErrores(th, 0, "GeneracionLecturaBLL->Aplicar_FinDeCiclo");
            return 6;
        }
    }

    async Aplicar_ConsumoPromedio() {
        try {
            if (this.gnMedia > this.gnConsumoMinimo) { // 20-11-2022
                this.gnConsumoFacturado = this.gnMedia;
            }

            const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
            const generacionLecturaDAL = new GeneracionLecturaDAL();
            const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();
   
            this.gnLecturaActual = this.gnLecturaAnterior;
            this.gnConsumoActual = this.gnMedia;
            this.gnMediaAnterior = true;

            const TipoReglaAplicar = medidorAnormalidadDAL.Aplicar_ConsumoPromedio;
            this.ValidoLectura = false;

            await generacionLecturaDAL.actualizarLecturaDAL(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual,
                this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado); // TODO: this.gnConsumoFacturado

            // Campos para la tabla GeneracionLecturaMovil
            this.AplicarPromedio = true;
            this.gnAjusteConsumo = 0;
            this.gnAjusteMonto = 0;
            // this.gnConsumoFacturado = this.gnMedia;
            this.DesviacionSignificativa = false;
            this.InspeccionRequerido = true;
            this.Facturado = true;

            const existe = await generacionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);
            if (existe.length > 0) {
                await generacionLecturaMovilDAL.Update(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            } else {
                await generacionLecturaMovilDAL.Insert(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            }

            return 0;

        } catch (th) {
            // GuardarErrores.GuardarErrores(th, 0, "GeneracionLecturaBLL->Aplicar_ConsumoPromedio");
            return 7;
        }
    }

    async Aplicar_MedidorVolcado() {
        try {
            const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();
            const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
            const generacionLecturaDAL = new GeneracionLecturaDAL();

            const TipoReglaAplicar = medidorAnormalidadDAL.Aplicar_MedidorVolcado;

            this.gnTipoConsumo = await this.CalcularConsumoXMedidorVolcado(this.gnCliente, this.gnGeneracionFactura, this.gnLecturaActual);
            this.ValidoLectura = true;

            await generacionLecturaDAL.actualizarLecturaDAL(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnLecturaActual,
                this.gnConsumoActual, this.gnMedidorAnormalidad, this.DataBaseAlias, this.ValidoLectura, this.gnConsumoFacturado); // TODO: this.gnConsumoFacturado

            // Campos para la tabla GeneracionLecturaMovil
            this.AplicarPromedio = false;
            this.gnAjusteConsumo = 0;
            this.gnAjusteMonto = 0;
            // this.gnConsumoFacturado = 0;
            this.DesviacionSignificativa = (this.gnTipoConsumo == this.TipoConsumo.ConsumoBajo || this.gnTipoConsumo == this.TipoConsumo.ConsumoAlto);

            const MedidorAnormalidad = await medidorAnormalidadDAL.GetRecDt(this.gnMedidorAnormalidad, this.DataBaseAlias);
            this.InspeccionRequerido = MedidorAnormalidad[0].Inspeccion;
            this.Facturado = false;

       
            const existe = await generacionLecturaMovilDAL.Existe(this.gnGeneracionFactura, this.gnCliente, this.DataBaseAlias);
            if (existe.length > 0) {
                await generacionLecturaMovilDAL.Update(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            } else {
                await generacionLecturaMovilDAL.Insert(TipoReglaAplicar, this.gnGeneracionFactura, this.gnCliente, this.gnCategoria, this.gnMedidor,
                    this.gnTipoConsumo, this.AplicarPromedio, this.gnConsumoFacturado, this.gnAjusteConsumo, this.gnAjusteMonto,
                    this.DesviacionSignificativa, this.InspeccionRequerido, this.Facturado, this.ValidoLectura, this.gnMedidorAnormalidad2, this.DataBaseAlias); // TODO : se hace uso de la variable
            }

            return 0;

        } catch (th) {
            // GuardarErrores.GuardarErrores(th, 0, "GeneracionLecturaBLL->Aplicar_MedidorVolcado");
            console.error("Error en GeneracionLecturaBLL->Aplicar_MedidorVolcado", th);
            
            return 8;
        }
    }

    Aplicar_ConsumoAsignado() {
        return 0;
    }


    Aplicar_AjusteLectura() {
        return 0;
    }

    Aplicar_InstalacionNueva() {
        return 0;
    }

    Aplicar_CambioDeMedidor() {
        return 0;
    }

    Aplicar_RegularizacionBajaTemporal() {
        return 0;
    }


    async CalcularConsumoXFinDeCiclo(Cliente, GeneracionFactura, LecturaActual) {
        try {
            // const MedidorDAL = new MedidorDAL(); // Deberás implementar MedidorDAL en JS
            const categoriaConsumoDAL = new CategoriaConsumoDAL(); // Deberás implementar CategoriaConsumoDAL en JS
    
            let lnResult = this.TipoConsumo.SinLectura;
            let LecturaMaxima = 0;
    
            // Obtener el medidor
            // const Medidor = await MedidorDAL.GetRecDt(this.gnMedidor, this.DataBaseAlias);
        
            const Medidor = [];
            Medidor.push({
                'NumeroSerie' : this.oClienteDatos.NumeroSerie,
                'Numero' : this.oClienteDatos.Numero,
                'FinMedidor' : this.oClienteDatos.FinMedidor,
                'MarcaMedidor' : this.oClienteDatos.MarcaMedidor
            })

            if (Medidor != null && Medidor.length > 0) {
                LecturaMaxima = Number(Medidor[0].FinMedidor);
            } else {
                return lnResult;
            }

            this.gnLecturaAnterior = Number(this.gnLecturaAnterior);
            this.gnLecturaActual = Number(this.gnLecturaActual);
            this.gnMedia = Number(this.gnMedia);
     
            // Calcular el consumo actual
            this.gnConsumoActual = (LecturaMaxima - this.gnLecturaAnterior) + this.gnLecturaActual + 1;
    
            // Calcular el porcentaje de desviación
            if (this.gnMedia == 0) {
                this.gnPorcentajeDesviacion = 0;
            } else {
                this.gnPorcentajeDesviacion = ((this.gnConsumoActual / this.gnMedia) - 1) * 100;
            }
    
            // Obtener límites de consumo
            const CategoriaConsumo = await categoriaConsumoDAL.Get_LimitesConsumo(this.gnCategoria, this.gnMedia, this.DataBaseAlias);
       
            const LimiteConsumoMinimo = CategoriaConsumo.Minimo;
            const LimiteConsumoMaximo = CategoriaConsumo.Maximo;
    
            if (this.gnConsumoActual < LimiteConsumoMinimo) {
                lnResult = this.TipoConsumo.ConsumoBajo;
            }else{
                if (this.gnConsumoActual > LimiteConsumoMaximo) {
                    lnResult = this.TipoConsumo.ConsumoAlto;
                }else {
                    lnResult = this.TipoConsumo.ConsumoNormal;
                }
            }
         
            return lnResult;
    
        } catch (error) {
            console.error("Error en CalcularConsumoXFinDeCiclo", error);
            return this.TipoConsumo.SinLectura; // Devolver valor predeterminado en caso de error
        }
    }
    
    async CalcularConsumoXMedidorVolcado(Cliente, GeneracionFactura, LecturaActual) {
        try {
      
            // const medidorDAL = new MedidorDAL(); // Instancia de la clase MedidorDAL
            const categoriaConsumoDAL = new CategoriaConsumoDAL(); // Instancia de la clase CategoriaConsumoDAL
    
            let lnResult = this.TipoConsumo.SinLectura;
            let LecturaMaxima = 0;
            this.gnLecturaActual = LecturaActual;
    
            // Obtener el medidor desde IndexedDB
            // const medidor = await medidorDAL.GetRecDt(this.gnMedidor, this.DataBaseAlias);
            const medidor = [];
            medidor.push({
                'NumeroSerie' : this.oClienteDatos.NumeroSerie,
                'Numero' : this.oClienteDatos.Numero,
                'FinMedidor' : this.oClienteDatos.FinMedidor,
                'MarcaMedidor' : this.oClienteDatos.MarcaMedidor
            })
    
            if (medidor != null && medidor.length > 0) {
                LecturaMaxima =  Number(medidor[0].FinMedidor);
            } else {
                return lnResult; // Retornar resultado sin lectura si no se encuentra el medidor
            }
    
            // Obtener los límites de consumo desde IndexedDB
            const categoriaConsumo = await categoriaConsumoDAL.Get_LimitesConsumo(this.gnCategoria, this.gnMedia, this.DataBaseAlias);
            const LimiteConsumoMinimo = categoriaConsumo.Minimo;
            const LimiteConsumoMaximo = categoriaConsumo.Maximo;
    
            // Calcular el consumo actua
     
            this.gnConsumoActual = Number(this.gnLecturaAnterior) - Number(this.gnLecturaActual);
    
            // Ajustar el consumo actual en caso de ser negativo
            if (this.gnConsumoActual < 0) {
                this.gnConsumoActual = (LecturaMaxima - Number(this.gnLecturaActual)) + Number(this.gnLecturaAnterior) + 1;
            } else if (this.gnConsumoActual > 0) {
                this.gnConsumoActual = Number(this.gnLecturaAnterior) - Number(this.gnLecturaActual);
            }
    
            // Calcular el porcentaje de desviación
            if (this.gnMedia == 0) {
                this.gnPorcentajeDesviacion = 0;
            } else {
                this.gnPorcentajeDesviacion = ((this.gnConsumoActual / this.gnMedia) - 1) * 100;
            }
    
            // Determinar el resultado basado en los límites de consumo
            if (this.gnConsumoActual < LimiteConsumoMinimo) {
                lnResult = this.TipoConsumo.ConsumoBajo;
            } else if (this.gnConsumoActual > LimiteConsumoMaximo) {
                lnResult = this.TipoConsumo.ConsumoAlto;
            } else {
                lnResult = this.TipoConsumo.ConsumoNormal;
            }
    
            return lnResult;
    
        } catch (error) {
            console.error("Error en CalcularConsumoXMedidorVolcado", error);
            // return this.TipoConsumo.SinLectura; // Devolver valor predeterminado en caso de error
            return null;
        }
    }
    

    async ActualizarLecturaMovilSinMedidor(GeneracionFactura, Cliente, Categoria, TipoConsumo, MedidorAnormalidad2, DataBaseAlias) {
        try {
        
            const generacionLecturaMovilDAL = new GeneracionLecturaMovilDAL();

            const TipoReglaAplicar = 1;
            const Medidor = 0;
        
            const existe = await generacionLecturaMovilDAL.Existe(GeneracionFactura, Cliente, DataBaseAlias);
                    if ( existe.length > 0) {
                        await generacionLecturaMovilDAL.Update(TipoReglaAplicar, GeneracionFactura, Cliente, Categoria, Medidor,
                            TipoConsumo, false, 0, 0, 0, false, false, false, true, MedidorAnormalidad2, DataBaseAlias);
                    }else {
                        await generacionLecturaMovilDAL.Insert(TipoReglaAplicar, GeneracionFactura, Cliente, Categoria, Medidor,
                            TipoConsumo, false, 0, 0, 0, false, false, false, true, MedidorAnormalidad2, DataBaseAlias);
                    }
            return  true;
        } catch (error) {
            console.error('Error actualizando o insertando en IndexedDB:', error);
            return false; // Retornar falso en caso de error
        }
    }
    
    


    //RESUELTO
    GetTipoConsumoStr() {
        let lnResult = "Ninguno";

        switch (Number(this.gnTipoConsumo)) {
            case 1:
                lnResult = "Consumo Normal";
                break;
            case 2:
                lnResult = "Consumo Bajo";
                break;
            case 3:
                lnResult = "Consumo Alto";
                break;
            case 4:
                lnResult = "Consumo Cero";
                break;
            case 5:
                lnResult = "Consumo Negativo";
                break;
            case 6:
                lnResult = "Sin Lectura";
                break;
            case 7:
                lnResult = "Consumo Estimado";
                break;
        }
        return lnResult;
    }


    //RESUELTO
    async GetTipoConsumo(GeneracionFactura, LecturaActual, Media) {
        // const categoriaDAL = new CategoriaDAL();

        // const generacionFacturaDAL = new GeneracionFacturaDAL();
        // const generacionFacturaData = await generacionFacturaDAL.GetRecDt(GeneracionFactura, this.DataBaseAlias);
        const generacionFacturaData = [];
        generacionFacturaData.push({
            Cobro: this.gnCobro
        });


        let MesCobro;
        if (generacionFacturaData.length > 0) {
            MesCobro = generacionFacturaData[0].Cobro;
        }

        let lnConsumoHistorico = Media;

        if (this.gnCategoria > 0) {
            // const categoriaDAL = new CategoriaDAL();
            // const laConsumoMinimo = await categoriaDAL.GetConsumoMinimo(this.gnCategoria, this.DataBaseAlias);
            const laConsumoMinimo = [];
            //TODO: REALIZAR CONSUTAL A LA indexDB
            laConsumoMinimo.push({
                ConsumoMinimo: this.oClienteDatos.ConsumoMinimo
            });
            
            this.gnConsumoMinimo = parseInt(laConsumoMinimo[0].ConsumoMinimo, 10);
        }

        //RESUELTO
        const categoriaConsumoDAL = new CategoriaConsumoDAL();
        const limiteConsumoDAL = await categoriaConsumoDAL.Get_LimitesConsumo(this.gnCategoria, lnConsumoHistorico, this.DataBaseAlias);
        const LimiteConsumoMaximo = limiteConsumoDAL.Maximo;
        const LimiteConsumoMinimo = limiteConsumoDAL.Minimo;

        this.gnLecturaActual = LecturaActual;
        this.gnConsumoActual = this.gnLecturaActual - this.gnLecturaAnterior;
        this.gnMedia = lnConsumoHistorico;

        if (lnConsumoHistorico == 0) {
            this.gnPorcentajeDesviacion = 0;
        } else {
            this.gnPorcentajeDesviacion = ((this.gnConsumoActual / lnConsumoHistorico) - 1) * 100;
        }
   
        // IDENTIFICACION DEL TIPO DE CONSUMO
        if (this.gnLecturaAnterior == 0 && this.gnLecturaActual == 0) {
            return this.TipoConsumo.ConsumoCero;
        }

        if (this.gnConsumoActual == 0) {
            return this.TipoConsumo.ConsumoCero;
        }

        if (LecturaActual <= 0) {
            return this.TipoConsumo.SinLectura;
        }

        if (this.gnConsumoActual < 0) {
            return this.TipoConsumo.ConsumoNegativo;
        }

        if (this.gnConsumoActual < LimiteConsumoMinimo) {
            return this.TipoConsumo.ConsumoBajo;
        } else if (this.gnConsumoActual > LimiteConsumoMaximo) {
            return this.TipoConsumo.ConsumoAlto;
        } else {
            return this.TipoConsumo.ConsumoNormal;
        }
    }
    
   
    //RESUELTO
    async GetTipoComportamiento(tcCliente, tcGeneracionLectura, tcLecturaActual) {
   
        let lnResult = 0;
        let lnFinMedidor = 0;
        let lnQmaxMes = 0;
        let lnFactorAnterior = 0;
        let lnFactorActual = 0;
        let lnDifFactores = 0;
        let lnFactorProximidadIzquierda = 0;
        let lnFactorProximidadDerecha = 0;
        let lnFactorLimiteConsumoNegativo = 0;
        let lnFactorLimiteConsumoPositivo = 0;

    
        try {
            // const GeneracionLecturaDAL = new GeneracionLecturaDAL();
            // const laMedidorDAL = await GeneracionLecturaDAL.ObtenerMedidor(this.gnMedidor, this.DataBaseAlias);
            const laMedidorDAL = [];
            laMedidorDAL.push({
                DiametroMedidor: this.oClienteDatos.DiametroMedidor, 
                FinMedidor: this.oClienteDatos.FinMedidor 
            });

            // const lnDiametroMedidorDAL = await GeneracionLecturaDAL.ObtenerDiametroMedidor(laMedidorDAL[0].DiametroMedidor, this.DataBaseAlias);
            //TODO: traer una tupla de la tabla de DiametroAcometida , de indexDB
            const lnDiametroMedidorDAL = [];

            //TODO: quitar despues de hacer le metodo de indexDB
            lnDiametroMedidorDAL.push({
                'CantidadMaximaMes' : this.oClienteDatos.CantidadMaximaMes
            });
      
            // const lnLecturaAnteriorDAL = await GeneracionLecturaDAL.GetRecDt2(tcGeneracionLectura, tcCliente, this.DataBaseAlias);
            // this.gnLecturaAnterior = lnLecturaAnteriorDAL[0].LecturaAnterior;
            this.gnLecturaAnterior = this.oClienteDatos.LecturaAnterior;

            if (laMedidorDAL.length > 0) {
                //Es un numero finito
                if (isFinite(laMedidorDAL[0].FinMedidor)) {
                    lnFinMedidor = laMedidorDAL[0].FinMedidor;
                } else {
                    lnResult = -12; // Registro no es Numero
                    this.cMessage = 'Medidor FinMedidor no es Numero';
                }
            } else {
                lnResult = -11; // Error No Existe Registro
                this.cMessage = 'No hay Registros para el Medidor ' + this.gnMedidor;
            }

            //si es menor a 0 es por que hubo error
            if (lnResult < 0) {
                return lnResult;
            }

            if (lnDiametroMedidorDAL.length > 0) {
                lnQmaxMes = lnDiametroMedidorDAL[0].CantidadMaximaMes;
            } else {
                lnResult = -11;
                this.cMessage = 'Diametro Acometida, No hay registros';
            }

            if (lnResult < 0) {
                return lnResult;
            }

            if (lnQmaxMes == 0) {
                this.cMessage = 'Diametro Acometida, No hay registros';
                return -1;
            }

            if (tcLecturaActual < 0) {
                return lnResult;
            }

            lnFactorAnterior = lnFinMedidor - this.gnLecturaAnterior;
            lnFactorActual = lnFinMedidor - tcLecturaActual;
            lnDifFactores = lnFactorAnterior - lnFactorActual;
            lnFactorProximidadIzquierda = (lnDifFactores / lnFinMedidor) * 100;
            lnFactorProximidadDerecha = 100 - Math.abs(lnFactorProximidadIzquierda);
            lnFactorLimiteConsumoPositivo = ((lnQmaxMes / lnFinMedidor) * 100);
            lnFactorLimiteConsumoNegativo = 100 - lnFactorLimiteConsumoPositivo;

            this.MedidorInfo.MedidorConsumo = tcLecturaActual - this.gnLecturaAnterior;
            this.MedidorInfo.MedidorDifFactores = lnDifFactores;
            this.MedidorInfo.MedidorFactorActual = lnFactorActual;
            this.MedidorInfo.MedidorFactorAnterior = lnFactorAnterior;
            this.MedidorInfo.MedidorFactorProximidadIzquierda = lnFactorProximidadIzquierda;
            this.MedidorInfo.MedidorFactorProximidadDerecha = lnFactorProximidadDerecha;
            this.MedidorInfo.MedidorFactorLimiteConsumoPositivo = lnFactorLimiteConsumoPositivo;
            this.MedidorInfo.MedidorFactorLimiteConsumoNegativo = lnFactorLimiteConsumoNegativo;
            this.MedidorInfo.MedidorFinMedidor = lnFinMedidor;
            this.MedidorInfo.MedidorLecturaActual = tcLecturaActual;
            this.MedidorInfo.MedidorLecturaAnterior = this.gnLecturaAnterior;
            this.MedidorInfo.MedidorTipoConsumo = this.TipoConsumo.ConsumoNegativo;
            this.MedidorInfo.MedidorCantidadMaximaMes = lnQmaxMes;

            lnResult = 0;

            // MEDIDOR FIN DE CICLO
            if (Math.abs(lnFactorProximidadIzquierda) >= lnFactorLimiteConsumoNegativo &&
                lnFactorProximidadDerecha <= lnFactorLimiteConsumoPositivo &&
                lnFactorProximidadIzquierda < 0 && lnFactorProximidadDerecha >= 0) {

                this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.FinDeCiclo;
                this.MedidorInfo.MedidorConsumo = Number(lnFinMedidor) - Number(this.gnLecturaAnterior) + Number(tcLecturaActual) + 1;
            // MEDIDOR VOLCADO EN LÍMITE
            } else if (lnFactorProximidadIzquierda >= lnFactorLimiteConsumoNegativo &&
                        lnFactorProximidadDerecha <= lnFactorLimiteConsumoPositivo &&
                        lnFactorProximidadIzquierda > 0 && lnFactorProximidadDerecha >= 0) {
                this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.VolcadoEnLimite;
                this.MedidorInfo.MedidorConsumo = Number(lnFinMedidor) - Number(tcLecturaActual) + Number(this.gnLecturaAnterior) + 1;
                // MEDIDOR VOLCADO ANTES DEL LÍMITE
            } else if (Math.abs(lnFactorProximidadIzquierda) <= lnFactorLimiteConsumoPositivo &&
                        lnFactorProximidadDerecha >= lnFactorLimiteConsumoNegativo &&
                        lnFactorProximidadIzquierda < 0 && lnFactorProximidadDerecha >= 0) {
                this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.VolcadoAntesDeLimite;
                this.MedidorInfo.MedidorConsumo = this.gnLecturaAnterior - tcLecturaActual;
                // MEDIDOR CON CONSUMO REAL
            } else if (lnFactorProximidadIzquierda <= lnFactorLimiteConsumoPositivo &&
                        lnFactorProximidadDerecha >= lnFactorLimiteConsumoNegativo &&
                        lnFactorProximidadIzquierda >= 0 && lnFactorProximidadDerecha >= 0) {
                this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.Lecturable;
                this.MedidorInfo.MedidorConsumo = tcLecturaActual - this.gnLecturaAnterior;
                this.MedidorInfo.MedidorTipoConsumo = this.TipoConsumo.ConsumoNormal;
                // MEDIDOR CON CONSUMO DESCONOCIDO IRREAL
            } else {
                this.MedidorInfo.MedidorTipoComportamiento = this.TipoComportamiento.Irreal;
                this.MedidorInfo.MedidorTipoConsumo = this.TipoConsumo.SinLectura;
            }

        } catch (th) {
            lnResult = -1;
            this.cMessage = 'Error al procesar [Tipo de Comportamiento]';
            const lcParametros = `tcCliente = ${tcCliente}, tcGeneracionLectura = ${tcGeneracionLectura}, tcLecturaActual = ${tcLecturaActual}`;
            // GuardarErrores.GuardarErrores(th, this.ID_Clase, `GetTipoComportamiento(${lcParametros})`);
        }
        return lnResult;
    }
       

    //RESUELTO
    async AnormalidadCorrecta(tcMedidorAnormalidad, tnTipoConsumo, tnTipoComportamiento) {  
        let lnResult = 0;
        const MedidorAnormalidad = new MedidorAnormalidadDAL();
        const loMedidorAnormalidad = await MedidorAnormalidad.GetReglaValida(tcMedidorAnormalidad, tnTipoConsumo, this.DataBaseAlias);
        // const loMedidorAnormalidad = []; //TODO: OJO AQUI, REVISAR, es otro tipo de conuslta, y no se enviar id de cliente
        // loMedidorAnormalidad.push({
        //     'Regla' : this.oClienteDatos.Regla
        // });


        if (loMedidorAnormalidad.length > 0) { // TODO && (dtMediEsta.Select(filtro).Length > 0)
    
            this.Regla = loMedidorAnormalidad[0].Regla;
    
            if (tnTipoComportamiento == this.TipoComportamiento.FinDeCiclo) {
                if (this.Regla != this.ReglaLecturacion.FIN_DE_CICLO) {
                    this.cMessage = 'Anormalidad seleccionada no tiene Regla: Fin de Ciclo';
                    return 3;
                }
            }
    
            if ((tnTipoComportamiento == this.TipoComportamiento.VolcadoAntesDeLimite) || (tnTipoComportamiento == this.TipoComportamiento.VolcadoEnLimite)) {
                if (this.Regla != this.ReglaLecturacion.MEDIDOR_VOLCADO) {
                    this.cMessage = 'Anormalidad seleccionada no tiene Regla: Medidor Volcado';
                    return 4;
                }
            }

             //TODO: RESULTADO 
       
            const loReglaLecturacionDetalle = new ReglaLecturacionDetalleDAL();
            const ReglaLec = await loReglaLecturacionDetalle.GetIDBy(this.Regla, this.DataBaseAlias);
            
            if (ReglaLec.length > 0) { // VERIFICAMOS SI LA REGLA ES APLICABLE AL TIPOCONSUMO
    
                const llAplicable = await loReglaLecturacionDetalle.ReglaAplicable(tnTipoConsumo);
    
                if (llAplicable == true) {
                    lnResult = 0; // Existe Anormalidad y su Tipo consumo es Valido
                    this.cMessage = "";
                } else {
                    lnResult = 2;
                    this.cMessage = "No Hay Regla Aplicable";
                }
            } else {
                lnResult = 2;
                this.cMessage = "No Hay Registros";
            }
    
        } else {
            lnResult = 2; // Existe Anormalidad pero posiblemente su tipo consumo no es correcto
            this.cMessage = "MediEsta[No Hay Registros o TipoConsumo no es Compatible con la Anormalidad]";
        }
        return lnResult;
    }

    //RESUELTO
    GetNombreTipoConsumo(tnTipoConsumo) {
        let lcResult = "";
        switch (Number(tnTipoConsumo)) {
            case 1:
                lcResult = "Consumo Normal";
                break;
            case 2:
                lcResult = "Consumo Bajo";
                break;
            case 3:
                lcResult = "Consumo Alto";
                break;
            case 4:
                lcResult = "Consumo Cero";
                break;
            case 5:
                lcResult = "Consumo Negativo";
                break;
            case 6:
                lcResult = "Sin Lectura";
                break;
            case 7:
                lcResult = "Consumo Asignado";
                break;
            case 8:
                lcResult = "Consumo Irreal";
                break;
            default:
                lcResult = ".NULL.";
                break;
        }
        return lcResult;
    }

    //RESUELTO
    async EsCasoSinLectura_AplicarPromedio(tcMedidorAnormalidad, tnTipoConsumo, tnLecturaAnterior, tnLecturaActual, tnConsumoActual, tnMedia, tnConsumoFacturado, tnConsumoMinimo) {
      
        let lnResult = 3;
        let lnMessageError = '';
        let lnTipoConsumoSistema = 0;

        const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
        const lnMedidorAnormalidad = await medidorAnormalidadDAL.EsCasoSinLectura(tcMedidorAnormalidad, this.DataBaseAlias);
        // const lnMedidorAnormalidad = [];
        //TODO: REALIZAR CONSULTA A LA TABLA DE MEDIDORANORMALIDAD

        if (lnMedidorAnormalidad.length > 0) {
            this.Regla = lnMedidorAnormalidad[0].Regla;
            lnTipoConsumoSistema = lnMedidorAnormalidad[0].TipoConsumo;

            if (tnLecturaActual == tnLecturaAnterior && tnConsumoActual == 0) {
                if (lnTipoConsumoSistema == this.TipoConsumo.SinLectura && this.Regla == this.ReglaLecturacion.CONSUMO_PROMEDIO) {
                    if (tnConsumoMinimo[0].ConsumoMinimo > 0 && tnConsumoFacturado <= tnConsumoMinimo[0].ConsumoMinimo && tnMedia <= tnConsumoMinimo[0].ConsumoMinimo) {
                        lnResult = 0;
                    } else if (tnConsumoFacturado != tnMedia) {
                        lnResult = 4;
                        lnMessageError = `ConsumoFacturado Inválido,  tnConsumoFacturado: ${tnConsumoFacturado} tnMedia: ${tnMedia}`;
                    } else {
                        lnResult = 0;
                    }
                } else {
                    lnResult = 2;
                    lnMessageError = "TipoConsumo no Compatible con la Anormalidad";
                }
            } else {
                lnResult = 2;
                lnMessageError = "TipoConsumo no Compatible con la Anormalidad";
            }
        } else {
            lnResult = 3;
            lnMessageError = "No Existe Anormalidad";
        }

        console.error(lnMessageError);
        return lnResult;
    }

    //RESUELTO
    async verificarAnormalidadesEspeciales() {
   
        this.gnAnormalidadEspecial = 0;
        let lcErrorEsInstalacionNueva = "";
         //RESUELTO
        const lnEsInstalacionNueva = await this.oAnormalidadCorrectaBLL.EsInstalacionNueva(
            this.gnGeneracionFactura,
            this.gnMedidorAnormalidad,
            this.gnCliente,
            this.gnCobro,
            this.DataBaseAlias,
            this.oClienteDatos.CantidadHistorico
        );

        if (this.oAnormalidadCorrectaBLL.cError != "") {
            lcErrorEsInstalacionNueva = this.oAnormalidadCorrectaBLL.cError;
        }

        if (lnEsInstalacionNueva == 0 || lnEsInstalacionNueva == 1) {
             //RESUELTO
            

            await this.AplicarRegla2(
                this.gnLecturaAnterior,
                this.gnLecturaActual,
                this.gnConsumoActual,
                this.gnMedia,
                this.gnMedidorAnormalidad,
                this.gnMedidor,
                this.DataBaseAlias
            );

            if (lnEsInstalacionNueva == 0) {
                this.nErrorAdvertencia = 1;
                this.cMessage = lcErrorEsInstalacionNueva;
            }

            this.gnAnormalidadEspecial = 1;
            return 1;
        } else {
             //RESUELTO
            const lnEsCambioMedidor = await this.oAnormalidadCorrectaBLL.EsCambioDeMedidor(
                this.gnGeneracionFactura,
                this.gnMedidorAnormalidad,
                this.gnCliente,
                this.DataBaseAlias
            );

            let lcErrorEsCambioMedidor = "";
            if (this.oAnormalidadCorrectaBLL.cError == "") {
                lcErrorEsCambioMedidor = this.oAnormalidadCorrectaBLL.cError;
            }

            if (lnEsCambioMedidor == 0 || lnEsCambioMedidor == 1) {
                //RESUELTO
            
      
                await this.AplicarRegla2(
                    this.gnLecturaAnterior,
                    this.gnLecturaActual,
                    this.gnConsumoActual,
                    this.gnMedia,
                    this.gnMedidorAnormalidad,
                    this.gnMedidor,
                    this.DataBaseAlias
                );

                if (lnEsInstalacionNueva == 0) {
                    this.nErrorAdvertencia = 1;
                    this.cMessage = lcErrorEsCambioMedidor;
                }

                this.gnAnormalidadEspecial = 2;
                return 1;
            } else {
                //RESUELTO
                const lnEsRegulaBajaTemporal = await this.oAnormalidadCorrectaBLL.EsRegularizacionBajaTemporal(
                    this.gnGeneracionFactura,
                    this.gnMedidorAnormalidad,
                    this.gnCliente,
                    this.DataBaseAlias
                );

                let lcErrorEsRegulaBajaTemporal = "";
                if (this.oAnormalidadCorrectaBLL.cError == "") {
                    lcErrorEsRegulaBajaTemporal = this.oAnormalidadCorrectaBLL.cError;
                }

                if (lnEsRegulaBajaTemporal == 0 || lnEsRegulaBajaTemporal == 1) {
                  //RESUELTO  
                   
                    await this.AplicarRegla2(
                        this.gnLecturaAnterior,
                        this.gnLecturaActual,
                        this.gnConsumoActual,
                        this.gnMedia,
                        this.gnMedidorAnormalidad,
                        this.gnMedidor,
                        this.DataBaseAlias
                    );

                    if (lnEsInstalacionNueva == 0) {
                        this.nErrorAdvertencia = 1;
                        this.cMessage = lcErrorEsRegulaBajaTemporal;
                    }

                    this.gnAnormalidadEspecial = 3;
                    return 1;
                }
            }
        }

        return 0;
    }

 //RESUELTO
    async AplicarRegla2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor, DataBaseAlias) {
         
        await this.verificarConsumoFacturado();

       const loMedidor = [];
         loMedidor.push({
            FinMedidor: this.oClienteDatos.FinMedidor
        });
       
        let lnFinMedidor = 0;

        if (loMedidor.length > 0) {
            lnFinMedidor = loMedidor[0].FinMedidor;
        }

       
        //TODO: esto es para saber la reglas si no me equivoco
        const medidorAnormalidadDAL = new MedidorAnormalidadDAL();
         //RESUELTO
        let TipoReglaAplicar = await medidorAnormalidadDAL.Get_TipoReglaAAplicar(MedidorAnormalidad, DataBaseAlias);

        MedidorAnormalidad = Number(MedidorAnormalidad);
        TipoReglaAplicar = Number(TipoReglaAplicar);
        // Convertir a número (manteniendo NaN si no es un número válido)
        tnLectAnt = Number(tnLectAnt);
        tnLectAct = Number(tnLectAct);
        tnConsumo = Number(tnConsumo);
        tnMedia = Number(tnMedia);
        MedidorAnormalidad = Number(MedidorAnormalidad);
        Medidor = Number(Medidor);
        lnFinMedidor = Number(lnFinMedidor);


        if (MedidorAnormalidad == 0) {
             //RESUELTO
             this.Aplicar_ConsumoNormal2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
        } else {
            switch (TipoReglaAplicar) {
                case 1:
                     this.Aplicar_LecturaPendiente2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 2:
                     this.Aplicar_LecturaActual2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 3:
                     this.Aplicar_FinDeCiclo2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor, lnFinMedidor);
                    break;
                case 4:
                     this.Aplicar_ConsumoPromedio2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 5:
                     this.Aplicar_MedidorVolcado2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor, lnFinMedidor);
                    break;
                case 6:
                     this.Aplicar_ConsumoAsignado2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 7:
                     this.Aplicar_AjusteLectura2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 8:
                     this.Aplicar_InstalacionNueva2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 9:
                    this.Aplicar_CambioDeMedidor2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                case 10:
                    this.Aplicar_RegularizacionBajaTemporal2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor);
                    break;
                default:
                    throw new Error("Tipo de regla no reconocida");
            }
        }

        return TipoReglaAplicar;
    }

     //RESUELTO
    Aplicar_ConsumoNormal2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = tnLectAct - tnLectAnt;
        this.gnConsumoFacturado = this.gnConsumoActual;
        this.gnMedia = tnMedia;
    }
 //RESUELTO
    Aplicar_LecturaPendiente2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnLecturaActual = 0;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = 0;
        this.gnConsumoFacturado = 0;
        this.gnMedia = tnMedia;
    }

    Aplicar_LecturaActual2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = tnLectAct - tnLectAnt;
        this.gnConsumoFacturado = this.gnConsumoActual;
        this.gnMedia = tnMedia;
    }

    Aplicar_FinDeCiclo2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor, FinMedidor) {
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnMedia = tnMedia;

        if (FinMedidor > 0) {
            const lecturaMax = FinMedidor;
            this.gnConsumoActual = Number(lecturaMax - this.gnLecturaAnterior) + Number(this.gnLecturaActual) + 1;
            this.gnConsumoFacturado = this.gnConsumoActual;
        }
    }

    Aplicar_ConsumoPromedio2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = 0;
        this.gnConsumoFacturado = tnMedia;
        this.gnMedia = tnMedia;
    }

    Aplicar_MedidorVolcado2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor, FinMedidor) {
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnMedia = tnMedia;

        this.gnConsumoActual = tnLectAnt - tnLectAct;
        this.gnConsumoFacturado = this.gnConsumoActual;

        if (FinMedidor > 0) {
            const lecturaMax = FinMedidor;
            if (this.gnConsumoActual < 0) {
                this.gnConsumoActual = (lecturaMax - this.gnLecturaActual) + this.gnLecturaAnterior + 1;
            } else if (this.gnConsumoActual > 0) {
                this.gnConsumoActual = tnLectAnt - tnLectAct;
            }
            this.gnConsumoFacturado = this.gnConsumoActual;
        }
    }

    Aplicar_ConsumoAsignado2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnMedia = tnMedia;
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = tnLectAnt - tnLectAct;
        this.gnConsumoFacturado = this.gnConsumoActual;
    }

    Aplicar_AjusteLectura2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnMedia = tnMedia;
        this.gnLecturaActual = tnLectAct;
        this.gnLecturaAnterior = tnLectAnt;
        this.gnConsumoActual = tnLectAnt - tnLectAct;
        this.gnConsumoFacturado = this.gnConsumoActual;
    }

    Aplicar_InstalacionNueva2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnMedia = tnMedia;

        if (tnLectAct < tnLectAnt) {
            this.gnLecturaActual = tnLectAnt;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = 0;
            this.gnConsumoFacturado = 0;
        } else {
            this.gnLecturaActual = tnLectAct;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = tnLectAct - tnLectAnt;
            this.gnConsumoFacturado = this.gnConsumoActual;
        }
    }

    Aplicar_CambioDeMedidor2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnMedia = tnMedia;
  
        if (tnLectAct < tnLectAnt) {
            this.gnLecturaActual = tnLectAnt;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = 0;
            this.gnConsumoFacturado = 0;
        } else {
            this.gnLecturaActual = tnLectAct;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = tnLectAct - tnLectAnt;
            this.gnConsumoFacturado = this.gnConsumoActual;
        }
    }

    Aplicar_RegularizacionBajaTemporal2(tnLectAnt, tnLectAct, tnConsumo, tnMedia, MedidorAnormalidad, Medidor) {
        this.gnMedia = tnMedia;

        if (tnLectAct < tnLectAnt) {
            this.gnLecturaActual = tnLectAnt;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = 0;
            this.gnConsumoFacturado = 0;
        } else {
            this.gnLecturaActual = tnLectAct;
            this.gnLecturaAnterior = tnLectAnt;
            this.gnConsumoActual = tnLectAct - tnLectAnt;
            this.gnConsumoFacturado = this.gnConsumoActual;
        }
    }

     //RESUELTO
    async verificarConsumoFacturado() {
        if (this.gnConsumoMinimo > 0 && this.gnConsumoActual < this.gnConsumoMinimo) {
          this.gnConsumoFacturado = this.gnConsumoMinimo;
        } else {
          this.gnConsumoFacturado = this.gnConsumoActual;
        }
     }




}
